import Vue from 'vue';
import Vuetify, {
  VCard,
  VRow,
  VCol,
  VTooltip,
  VTextField,
  VCheckbox,
  VSelect,
  VCombobox,
  VAutocomplete,
  VRadio,
  VSlider,
  VSpacer,
  VSubheader,
  VFileInput,
  VSwitch,
  VIcon,
  VBtn,
  VTextarea,
  VLabel,
  VListItemContent,
  VListItemIcon,
  VListItem,
  VListItemGroup,
  VList,
  VToolbar,
  VToolbarTitle,
  VListItemTitle,
  VSheet,
  VTreeview,
  VDivider,
} from 'vuetify/lib';
import { Ripple, Intersect, Touch, Resize, ClickOutside } from 'vuetify/lib/directives';

Vue.use(Vuetify, {
  components: {
    VCard,
    VRow,
    VCol,
    VTooltip,
    VTextField,
    VCheckbox,
    VSelect,
    VCombobox,
    VAutocomplete,
    VRadio,
    VSlider,
    VSpacer,
    VSubheader,
    VFileInput,
    VSwitch,
    VIcon,
    VBtn,
    VTextarea,
    VLabel,
    VListItemContent,
    VListItemIcon,
    VListItem,
    VListItemGroup,
    VList,
    VToolbar,
    VToolbarTitle,
    VListItemTitle,
    VSheet,
    VTreeview,
    VDivider,
  },
  directives: { Ripple, Intersect, Touch, Resize, ClickOutside },
});

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#78AFF5', // colors.blue.accent-1 (Azul MainHeader) Antes: #82B1FF
        primary2: '#1A237E', // colors.indigo.darken-4 (Azul Logo)
        primary3: '#FFA726', // colors.orange.lighten-1 (Naranja Logo)
        primary4: '#448AFF', // colors.blue.accent-2 (Azul Claro)
        primary5: '#E3F2FD', // colors.blue.lighten-5 (Azul + Claro)
        primary6: '#cdddf7', // colors.blue.lighten-1-modificado (Azul + Clarox2)
        secundary: '#787878', // colors.grey.darken-1 (Gris)  Antes: #767676
        secundary2: '#1976D2', // colors.blue.darken-2 (Azul Botones)
        secundary3: '#C8E6C9', // colors.green.lighten-4 (Verde Botones)
        secundary4: '#BDBDBD', // colors.grey.lighten-1 (Gris Claro)
        secundary5: '#EEEEEE', // colors.grey.lighten-3 (Gris Ligero)
        secundary6: '#616161', // colors.grey.darken-2 (Gris Oscuro)
        secundary7: '#00B0FF', // colors.grey.darken-2 (Gris Oscuro)
        secundary8: '#FAFAFA', // Gray 50 (Gris super claro)
      },
    },
  },
  customPropierties: true,
  iconfont: 'md',
});
